export { ThreadParticipantAvatarGroup } from './ThreadParticipantAvatarGroup';
